<template>
  <module-page v-bind="pageParams">
    <screen-loading v-if="!loaded"></screen-loading>
    <iframe
      v-show="loaded"
      scrolling="yes"
      ref="iframe"
      @load="load"
      class="news__iframe"
      :style="{ height }"
      :src="url"
    />
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import enums from '../../utils/enums';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { CONFIG, IFRAME } from '../../utils/constants';
import handlebars from '../../services/handlebars';

export default {
  name: 'news-awards',
  components: {
    ModulePage,
    ScreenLoading,
  },
  computed: {},
  data() {
    return {
      url: null,
      height: '1500px',
      loaded: false,
      pageParams: {},
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      const newsPath = this.$route.params.type;
      const newsTypes = this.$store.getters[IFRAME.GET_NEWS_TYPES];
      const selectedType = newsTypes.find(
        (news) => this.$t(`pages.news.${news.type}.path`) === newsPath
      );
      if (selectedType) {
        this.pageParams = {
          title: this.$t(`pages.news.${selectedType.type}.title`),
          icon: 'news',
          description: '',
          themeColor: '#0093f0',
        };
        try {
          const data = this.$store.getters[IFRAME.GET_DATA];
          if (data) {
            const mask = selectedType.mask;
            this.height = selectedType.height || '1500px';
            const template = handlebars.compile(mask);
            const url = template(data);
            this.url = url;
          }
        } catch (error) {
          console.error(error.toString());
        }
        this.loaded = true;
      }
    },
  },
  watch: {
    $route() {
      this.load();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
.news {
  &__iframe {
    width: 100%;
    height: 100%;
    min-width: 1021px;
    min-height: 59vh;
    border: none;
    margin-bottom: 10px;
    @include breakpoint(mobile) {
      min-width: initial;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/news/Iframe.vue